import { Component } from '@angular/core';
import { PermaBaseComponent } from './perma-base.component';
import { RBCheck } from '@ldw/roesberg';

@Component({
    selector: 'ldw-docsearch',
    templateUrl: './component.html',
    styleUrls: ['./component.css'],
    standalone: false
})
export class DocSearchComponent extends PermaBaseComponent {
  protected process() {
    if (RBCheck.isNullOrEmpty(this.doc)) {
      // no searchtext given, so go to root of documents
      this.routerService.navigateToDocuments(this.webDokuId, '');
      return;
    }
    // we search for searchtext
    this.routerService.navigateToDocumentSearch(this.webDokuId, this.doc);
  }
}
